import React from "react";

export default function NotFound() {
  return (
    <div className='not-found'>
      <h1>404 - Page Not Found</h1>
    </div>
  );
}
